/**
 *
 * @param {GroupClassProps} group
 * @param {GroupAttributesProps} attributes
 */
const processAttributes = (group, attributes) => {
  const result = new Set();

  for (const [target, set] of attributes) {
    const joined = Array.from(set).join(" ")

    target.dataset.tor = joined;
    result.add(target);
  }

  return result;
};

export default processAttributes;
